// Builds the meal object a MealCard renders for a daily-plan row.
//
// `details` is the (optional) GET /meals/{id} result. When it is missing (custom
// meals, AI logs, Spoonacular items, or a details fetch that failed/timed out) the
// card renders from the plan row itself. Either way the row's saved image_url must
// survive: for an AI photo log it is the stable private marker
// "/api/ai-log/photo/{meal_id}" that MealCard resolves via useMealImageSrc — never
// a signed URL — so dropping it here turns the photo into a placeholder.
export function mealFromPlanRow(planItem, details, fallbackName) {
  var row = planItem || {};
  var rowImage = row.image_url || null;
  if (details) {
    if (details.image_url || !rowImage) return details;
    return Object.assign({}, details, { image_url: rowImage });
  }
  var macros = row.macros || {};
  return {
    meal_id: row.meal_id,
    name: row.meal_name || fallbackName || 'Logged Food',
    calories: macros.calories || 0,
    protein: macros.protein || 0,
    carbs: macros.carbs || 0,
    fat: macros.fat || 0,
    image_url: rowImage,
    source: row.source || 'CUSTOM'
  };
}
